import { render, staticRenderFns } from "./talentGrowth.vue?vue&type=template&id=39e36448&"
import script from "./talentGrowth.vue?vue&type=script&lang=js&"
export * from "./talentGrowth.vue?vue&type=script&lang=js&"
import style0 from "./talentGrowth.vue?vue&type=style&index=0&id=39e36448&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports